// @ts-nocheck
import React from "react";
import { Helmet } from "react-helmet";
import { Link, useRouteError } from "react-router-dom";
import err404Img from "../../assets/images/404.png";
import err500Img from "../../assets/images/500.png";
import { Footer } from "layout/footer";
import { Header } from "layout/header";
import  Sidebar  from "layout/Sidebar";
import "../../styles/errPage.css";
import { ROUTES_PATHS } from "const";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header />
      <Sidebar />
      <main id='error'>
        <section className='errPage'>
          <div className='errPage-wrap'>
            {error?.status === 404 ? (
              <>
                <img loading="lazy" src={err404Img} alt='404 error' />
                <div className='errPage-content'>
                  <div className='errPage-content-wrap'>
                    <h2 className='errPage-content__shout'>код ошибки: 404</h2>
                    <h1 className='errPage-content__title'>
                      Страница не найдена
                    </h1>
                    <p className='errPage-content__subtitle'>
                      Похоже, мы не можем найти нужную вам страницу :(
                    </p>
                    <Link
                      to={ROUTES_PATHS.MAIN}
                      className='form-success-button errPage-content__btn'
                    >
                      Ладненько
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <>
                <img loading="lazy" src={err500Img} alt='404 error' />
                <div className='errPage-content'>
                  <div className='errPage-content-wrap'>
                    <h2 className='errPage-content__shout'>код ошибки: 500</h2>
                    <h1 className='errPage-content__title'>
                      Сервер не отвечает ;(
                    </h1>
                    <p className='errPage-content__subtitle'>
                      Возможно, проводятся технические работы
                    </p>
                    <Link
                      to={ROUTES_PATHS.MAIN}
                      className='form-success-button errPage-content__btn'
                    >
                      Ладненько
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
